export interface ConfigOptions {
  default?: {[key: string]: any};
  path?: string;
}
